module.exports = __webpack_public_path__ + "img/157.35af798a.jpg";